import { jsxs as t, Fragment as o } from "react/jsx-runtime";
import { isValidElement as s, cloneElement as m } from "react";
const l = (e, r, n = !1) => n && s(e) ? m(
  e,
  void 0,
  /* @__PURE__ */ t(o, { children: [
    e.props.children,
    r
  ] })
) : /* @__PURE__ */ t(o, { children: [
  e,
  r
] });
export {
  l as appendToChildren
};
